<template>
<!-- Button trigger modal -->
<button v-if="showInstallButton" type="button" class="btn btn-warning w-100 rounded-0 mb-0" data-bs-toggle="modal" data-bs-target="#exampleModal">
    نصب اپلیکیشن موبایل</button>
  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">نصب اپلیکیشن</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          برای نصب اپلیکیشن بر روی صفحه دکمه "نصب" بزنید.
  
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
          <button @click="promptInstall" type="button" data-bs-dismiss="modal" class="btn btn-primary">نصب</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: "App",
  setup() {
    const showInstallButton = ref(false);
    let deferredPrompt;

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt = e;
      showInstallButton.value = true;
    });

    const promptInstall = async () => {
      if (!deferredPrompt) {
        return;
      }
      deferredPrompt.prompt();
      const result = await deferredPrompt.userChoice;
      console.log(`User choice: ${result.outcome}`);
      deferredPrompt = null;
      showInstallButton.value = false;
    };

    return {
      promptInstall,
      showInstallButton,
    };
  },
};
</script>

<style>

</style>